export const ADMISSION_STATUSES = [
    'In progress',
    'Submitted to Insurance',
    'Insurance Approved',
    'Insurance Denied',
    'Rejected',
    'Admitted',
    'Closed',
];

export const ACTIVE_ADMISSION_STATUSES = ADMISSION_STATUSES.filter(
    (s) => s !== 'Closed'
);

export const ADMISSION_STATUS_COLORS = {
    'In progress':           '#5b8def',
    'Submitted to Insurance': '#6cc4a1',
    'Insurance Approved':    '#7fd1ae',
    'Insurance Denied':      '#e58a8a',
    'Rejected':              '#d97c7c',
    'Admitted':              '#f0b46a',
    'Closed':                '#9aa0a6',
};

export const ADMISSION_STATUS_SHORT_LABELS = {
    'In progress':           'In prog',
    'Submitted to Insurance': 'Submit',
    'Insurance Approved':    'Approv',
    'Insurance Denied':      'Deny',
    'Rejected':              'Reject',
    'Admitted':              'Admit',
    'Closed':                'Closed',
};

// Stable display order for closed-case outcomes (positive → negative → indeterminate).
// "Closed" is a catch-all for legacy/dev cases archived before terminal_outcome
// was preserved.
export const CLOSED_OUTCOMES = [
    'Admitted',
    'Insurance Approved',
    'Insurance Denied',
    'Rejected',
    'Submitted to Insurance',
    'In progress',
    'Closed',
];

// Maps an admission_status (or terminal_outcome) string to the CSS modifier
// class used by the .admission-pill rules in CaseManagement.css.
export function pillClassFor(status) {
    const l = (status || 'In progress').toLowerCase();
    if (l === 'closed') return 'closed';
    if (l === 'in progress') return 'working';
    if (l === 'submitted to insurance') return 'submitted';
    if (l === 'insurance approved' || l === 'admitted') return 'success';
    if (l === 'insurance denied' || l === 'rejected') return 'error';
    return 'working';
}
